import stoneDataTableColumn from '@/components/stone-data-table-column'
export default {
  components: {stoneDataTableColumn},
  props: {
    tableRef: {
      type: String,
      required: false,
      default: () => 'stoneDataTable'
    },
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    tableProps: {
      type: Object,
      required: false,
      default: () => {}
    },
    paginationProps: {
      type: Object,
      required: false,
      default: () => {}
    },
    colNotRowClick: {
      type: Array,
      required: false
    },
    actionsDef: {
      type: Object,
      required: false
    },
    actionCol: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    currentRow: {
      type: Object,
      required: false
    },
    layout: {
      type: String,
      required: false,
      default: 'table, pagination'
    },
    filters: {
      type: [Object, Array],
      required: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      localTableColumns: this.columns,
      localData: this.data,
      localColNotRowClick: this.colNotRowClick,
      localActionsDef: this.actionsDef,
      localActionCol: this.actionCol,
      localLoading: this.loading,
      localTableRef: this.tableRef,
      localLayout: this.layout,
      localFilters: this.filters,
      localCurrentPage: this.currentPage,
      localPageSize: this.pageSize
    }
  },
  computed: {
    // 테이블 속성
    localTableProps: function () {
      const props = Object.assign({
        border: true,
        headerCellClassName: '',
        sortable: true,
        stripe: false,
        emptyText: '검색결과가 없습니다.'
      }, this.tableProps)
      return props
    },
    // 페이징 속성
    localPaginationProps: function () {
      return Object.assign({
        background: false,
        layout: 'prev, pager, next'
      }, this.paginationProps)
    }
  },
  methods: {
    // row click 이벤트
    handleRowClick (row, event, column) {
      this.$emit('row-click', row, event, column)
    },
    handleSelectionChange (value) {
      this.$emit('selection-change', value)
    },
    handleCurrentChange (value) {
      this.$emit('current-change', value)
    },
    handleCurrentPageChange (value) {
      this.$emit('current-page-change', value)
    },
    getSortable: function (value) {
      if (!this.localTableProps.sortable) {
        return false
      }
      return value ? 'custom' : true
    },
    handleQueryChange (queryInfo) {
      this.$emit('query-change', queryInfo)
    },
    handleCellClick (row, column, cell, event) {
      this.$emit('cell-click', row, column, cell, event)
    },
    handleSortChange ({ column, prop, order }) {
      this.$emit('sort-change', { column, prop, order })
    },
    handleFilterChange (filters) {
      this.$emit('filter-change', filters)
    }
  },
  watch: {
    data: function (value) {
      this.localData = value
    },
    loading: function (value) {
      this.localLoading = value
    },
    currentRow: function (value) {
      if (this.localTableRef) {
        this.$refs[this.localTableRef].$refs.elTable.setCurrentRow(value)
      }
    },
    currentPage: function (value) {
      this.localCurrentPage = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/stone-data-table.js